module.exports = __webpack_public_path__ + "img/holland-eredivisie-16__dark.62c00a24.png";